import React from 'react';
import ErrorPage from './ErrorPage';

// 404 Not Found Error Page
export const NotFoundPage: React.FC = () => (
  <ErrorPage
    errorCode="404"
    title="Page Not Found"
    message="The page you're looking for doesn't exist or has been moved to a different location."
    showHomeButton={true}
    showBackButton={true}
  />
);


// 500 Server Error Page
export const ServerErrorPage: React.FC = () => (
  <ErrorPage
    errorCode="500"
    title="Server Error"
    message="Something went wrong on our end. Please try again later or contact support if the problem persists."
    showHomeButton={true}
    showBackButton={false}
  />
);

// 403 Forbidden Error Page
export const ForbiddenPage: React.FC = () => (
  <ErrorPage
    errorCode="403"
    title="Access Forbidden"
    message="You don't have permission to access this page. Please log in or contact an administrator."
    showHomeButton={true}
    showBackButton={true}
  />
);

// 401 Unauthorized Error Page
export const UnauthorizedPage: React.FC = () => (
  <ErrorPage
    errorCode="401"
    title="Unauthorized Access"
    message="Please log in to access this page. You need to be authenticated to view this content."
    showHomeButton={true}
    showBackButton={true}
  />
);

// Network Error Page
export const NetworkErrorPage: React.FC = () => (
  <ErrorPage
    errorCode="🌐"
    title="Network Error"
    message="Unable to connect to the server. Please check your internet connection and try again."
    showHomeButton={true}
    showBackButton={true}
  />
);

// Maintenance Page
export const MaintenancePage: React.FC = () => (
  <ErrorPage
    errorCode="🔧"
    title="Under Maintenance"
    message="We're currently performing maintenance to improve your experience. Please check back soon!"
    showHomeButton={true}
    showBackButton={false}
  />
);

// Custom Error Page Hook
export const useErrorPage = (errorCode?: string) => {
  switch (errorCode) {
    case '404':
      return NotFoundPage;
    case '500':
      return ServerErrorPage;
    case '403':
      return ForbiddenPage;
    case '401':
      return UnauthorizedPage;
    case 'network':
      return NetworkErrorPage;
    case 'maintenance':
      return MaintenancePage;
    default:
      return NotFoundPage;
  }
}; 